export default "__VITE_ASSET__UoXMngXX__"